<script>
  export default {
    props: {
      imageUrl: {
        type: String,
        required: true,
      },
      altText: {
        type: String,
        required: true,
      },
    },
  };
</script>

<template>
  <picture class="picture">
    <img
      class="picture/image"
      style="object-fit: contain;"
      draggable="false"
      :src="imageUrl"
      loading="lazy"
      onerror="window.MoMA.onImageError(this, 1)"
      :alt="altText"
    >
  </picture>
</template>